<template>
	<div class="home-page" @click="closeUserInfo">
		<div class="app-container" :class="{ fullscreen: configStore.fullScreen }">
			<!-- 桌面端左侧导航 -->
			<div class="navi-bar desktop-nav">
				<div class="navi-bar-box">
					<div class="top">
						<div class="user-head-image">
							<head-image :name="userStore.userInfo.nickName" :size="38"
								:url="userStore.userInfo.headImageThumb" @click.native="showSettingDialog = true">
							</head-image>
						</div>
						<div class="menu">
							<router-link class="link" v-bind:to="'/home/chat'">
								<div class="menu-item">
									<span class="icon iconfont icon-chat"></span>
									<div v-show="unreadCount > 0" class="unread-text">{{ unreadCount }}</div>
								</div>
							</router-link>
							<router-link class="link" v-bind:to="'/home/friend'">
								<div class="menu-item">
									<span class="icon iconfont icon-friend"></span>
								</div>
							</router-link>
							<router-link class="link" v-bind:to="'/home/group'">
								<div class="menu-item">
									<span class="icon iconfont icon-group" style="font-size: 28px"></span>
								</div>
							</router-link>
						</div>
					</div>

					<div class="botoom">
						<div class="bottom-item" @click="onSwtichFullScreen">
							<i class="el-icon-full-screen"></i>
						</div>
						<div class="bottom-item" @click="showSetting">
							<span class="icon iconfont icon-setting" style="font-size: 20px"></span>
						</div>
						<div class="bottom-item" @click="onExit()" title="退出">
							<span class="icon iconfont icon-exit"></span>
						</div>
					</div>
				</div>
			</div>

			<div class="content-box">
				<router-view class="router-content"></router-view>
			</div>

			<!-- 移动端底部导航 -->
			<div class="mobile-nav">
				<router-link class="nav-item" v-bind:to="'/home/chat'">
					<span class="icon iconfont icon-chat"></span>
					<span class="nav-text">会话</span>
					<div v-show="unreadCount > 0" class="unread-badge">{{ unreadCount }}</div>
				</router-link>
				<router-link class="nav-item" v-bind:to="'/home/friend'">
					<span class="icon iconfont icon-friend"></span>
					<span class="nav-text">好友</span>
				</router-link>
				<router-link class="nav-item" v-bind:to="'/home/group'">
					<span class="icon iconfont icon-group"></span>
					<span class="nav-text">群聊</span>
				</router-link>
				<div class="nav-item" @click="showSettingDialog = true">
					<span class="icon iconfont icon-setting"></span>
					<span class="nav-text">我的</span>
				</div>
			</div>

			<setting :visible="showSettingDialog" @close="closeSetting()"></setting>
			<user-info ref="userInfo"></user-info>
			<full-image ref="fullImage"></full-image>
			<rtc-private-video ref="rtcPrivateVideo"></rtc-private-video>
			<rtc-group-video ref="rtcGroupVideo"></rtc-group-video>
		</div>
	</div>
</template>

<script>
import HeadImage from '../components/common/HeadImage.vue';
import Setting from '../components/setting/Setting.vue';
import UserInfo from '../components/common/UserInfo.vue';
import FullImage from '../components/common/FullImage.vue';
import RtcPrivateVideo from '../components/rtc/RtcPrivateVideo.vue';
import RtcPrivateAcceptor from '../components/rtc/RtcPrivateAcceptor.vue';
import RtcGroupVideo from '../components/rtc/RtcGroupVideo.vue';

export default {
	components: {
		HeadImage,
		Setting,
		UserInfo,
		FullImage,
		RtcPrivateVideo,
		RtcPrivateAcceptor,
		RtcGroupVideo
	},
	data() {
		return {
			showSettingDialog: false,
			lastPlayAudioTime: new Date().getTime() - 1000,
			reconnecting: false
		}
	},
	methods: {
		init() {
			this.$eventBus.$on('openPrivateVideo', (rctInfo) => {
				this.$refs.rtcPrivateVideo.open(rctInfo);
			});
			this.$eventBus.$on('openGroupVideo', (rctInfo) => {
				this.$refs.rtcGroupVideo.open(rctInfo);
			});
			this.$eventBus.$on('openUserInfo', (user, pos, group) => {
				this.$refs.userInfo.open(user, pos, group);
			});
			this.$eventBus.$on('openFullImage', url => {
				this.$refs.fullImage.open(url);
			});
			window.showFullImage = (url) => {
				this.$refs.fullImage.open(url);
			};

			this.configStore.setAppInit(false)
			this.loadStore().then(() => {
				const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
				const wsurl = protocol + '://xxdatapush.cn/box-ws';
				this.$wsApi.connect(wsurl, sessionStorage.getItem("accessToken"));
				this.$wsApi.onConnect(() => {
					if (this.reconnecting) {
						this.onReconnectWs();
					} else {
						this.loadUnreadSummaries();
						this.configStore.setAppInit(true);
					}
				});
				this.$wsApi.onMessage((cmd, msgInfo) => {
					if (cmd == 2) {
						this.$wsApi.close(3000)
						this.$alert("您已在其他地方登录，将被强制下线", "强制下线通知", {
							confirmButtonText: '确定',
							callback: action => {
								location.href = "/";
							}
						});
					} else if (cmd == 3) {
						this.handlePrivateMessage(msgInfo);
					} else if (cmd == 4) {
						this.handleGroupMessage(msgInfo);
					} else if (cmd == 5) {
						this.handleSystemMessage(msgInfo);
					}
				});
				this.$wsApi.onClose((e) => {
					if (e.code != 3000) {
						if (!this.reconnecting) {
							this.reconnectWs();
							this.configStore.setAppInit(false)
						}
					}
				});
			}).catch((e) => {
				console.log("初始化失败", e);
			})
		},
		reconnectWs() {
			this.reconnecting = true;
			this.userStore.loadUser().then(() => {
				this.$message.error("连接断开，正在尝试重新连接...");
				const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
				const wsurl = protocol + '://xxdatapush.cn/box-ws';
				this.$wsApi.reconnect(wsurl, sessionStorage.getItem("accessToken"));
			}).catch(() => {
				setTimeout(() => this.reconnectWs(), 10000)
			})
		},
		onReconnectWs() {
			this.reconnecting = false;
			const promises = [];
			promises.push(this.friendStore.loadFriend());
			promises.push(this.groupStore.loadGroup());
			Promise.all(promises).then(() => {
				this.loadUnreadSummaries();
				this.configStore.setAppInit(true)
				this.$message.success("重新连接成功");
			}).catch(() => {
				this.$message.error("初始化失败");
				this.onExit();
			})
		},
		loadStore() {
			return this.userStore.loadUser().then(() => {
				const promises = [];
				promises.push(this.friendStore.loadFriend());
				promises.push(this.groupStore.loadGroup());
				promises.push(this.chatStore.loadChat());
				promises.push(this.configStore.loadConfig());
				return Promise.all(promises);
			})
		},
		unloadStore() {
			this.friendStore.clear();
			this.groupStore.clear();
			this.chatStore.clear();
			this.userStore.clear();
		},
		loadUnreadSummaries() {
			const promises = [];
			promises.push(this.$http({
				url: '/message/private/conversations',
				method: 'GET'
			}));
			promises.push(this.$http({
				url: '/message/group/conversations',
				method: 'GET'
			}));
			Promise.all(promises).then(([privateSummaries, groupSummaries]) => {
				this.chatStore.applyConversationSummaries([
					...(privateSummaries || []),
					...(groupSummaries || [])
				]);
			}).catch(e => {
				console.log('拉取会话摘要失败', e);
			});
		},
		handlePrivateMessage(msg) {
			msg.selfSend = msg.sendId == this.userStore.userInfo.id;
			let friendId = msg.selfSend ? msg.recvId : msg.sendId;
			let chatInfo = {
				type: 'PRIVATE',
				targetId: friendId
			}
			if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
				this.chatStore.resetUnreadCount(chatInfo)
				return;
			}
			if (msg.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
				this.chatStore.readedMessage({
					friendId: msg.sendId
				})
				return;
			}
			if (msg.type == this.$enums.MESSAGE_TYPE.RECALL) {
				this.chatStore.recallMessage(msg, chatInfo)
				return;
			}
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_NEW) {
				this.friendStore.addFriend(JSON.parse(msg.content));
				return;
			}
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_DEL) {
				this.friendStore.removeFriend(friendId);
				return;
			}
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_DND) {
				this.friendStore.setDnd(friendId, JSON.parse(msg.content));
				this.chatStore.setDnd(chatInfo, JSON.parse(msg.content));
				return;
			}
			if (this.$msgType.isRtcPrivate(msg.type)) {
				this.$refs.rtcPrivateVideo.onRTCMessage(msg)
				return;
			}
			if (this.$msgType.isNormal(msg.type) || this.$msgType.isTip(msg.type) || this.$msgType.isAction(msg.type)) {
				let friend = this.loadFriendInfo(friendId);
				this.insertPrivateMessage(friend, msg);
				if (msg.id && !msg.selfSend) {
					this.chatStore.readedMessage({
						friendId: friendId,
						maxId: msg.id
					});
				}
			}
		},
		insertPrivateMessage(friend, msg) {
			let chatInfo = {
				type: 'PRIVATE',
				targetId: friend.id,
				showName: friend.nickName,
				headImage: friend.headImage,
				isDnd: friend.isDnd
			};
			this.chatStore.openChat(chatInfo);
			this.chatStore.insertMessage(msg, chatInfo);
			if (!friend.isDnd && !msg.selfSend && this.$msgType.isNormal(msg.type) &&
				msg.status != this.$enums.MESSAGE_STATUS.READED) {
				this.playAudioTip();
			}
		},
		handleGroupMessage(msg) {
			msg.selfSend = msg.sendId == this.userStore.userInfo.id;
			let chatInfo = {
				type: 'GROUP',
				targetId: msg.groupId
			}
			if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
				this.chatStore.resetUnreadCount(chatInfo)
				return;
			}
			if (msg.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
				let msgInfo = {
					id: msg.id,
					groupId: msg.groupId,
					readedCount: msg.readedCount,
					receiptOk: msg.receiptOk
				};
				this.chatStore.updateMessage(msgInfo, chatInfo)
				return;
			}
			if (msg.type == this.$enums.MESSAGE_TYPE.RECALL) {
				this.chatStore.recallMessage(msg, chatInfo)
				return;
			}
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_NEW) {
				this.groupStore.addGroup(JSON.parse(msg.content));
				return;
			}
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_DEL) {
				this.groupStore.removeGroup(msg.groupId);
				return;
			}
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_DND) {
				this.groupStore.setDnd(msg.groupId, JSON.parse(msg.content));
				this.chatStore.setDnd(chatInfo, JSON.parse(msg.content));
				return;
			}
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_MUTE) {
				let isMuted = JSON.parse(msg.content);
				this.groupStore.setMute(msg.groupId, isMuted);
				return;
			}
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_FORBID_PRIVATE_CHAT) {
				let isForbidPrivateChat = JSON.parse(msg.content);
				this.groupStore.setForbidPrivateChat(msg.groupId, isForbidPrivateChat);
				return;
			}
			if (this.$msgType.isRtcGroup(msg.type)) {
				this.$nextTick(() => {
					this.$refs.rtcGroupVideo.onRTCMessage(msg);
				})
				return;
			}
			if (this.$msgType.isNormal(msg.type) || this.$msgType.isTip(msg.type) || this.$msgType.isAction(msg.type)) {
				let group = this.loadGroupInfo(msg.groupId);
				this.insertGroupMessage(group, msg);
			}
		},
		insertGroupMessage(group, msg) {
			let chatInfo = {
				type: 'GROUP',
				targetId: group.id,
				showName: group.showGroupName,
				headImage: group.headImageThumb,
				isDnd: group.isDnd
			};
			this.chatStore.openChat(chatInfo);
			this.chatStore.insertMessage(msg, chatInfo);
			if (!group.isDnd && !msg.selfSend && this.$msgType.isNormal(msg.type) &&
				msg.status != this.$enums.MESSAGE_STATUS.READED) {
				this.playAudioTip();
			}
		},
		handleSystemMessage(msg) {
			if (msg.type == this.$enums.MESSAGE_TYPE.USER_BANNED) {
				this.$wsApi.close(3000);
				this.$alert("您的账号已被管理员封禁,原因:" + msg.content, "账号被封禁", {
					confirmButtonText: '确定',
					callback: () => {
						this.onExit();
					}
				});
				return;
			}
		},
		closeUserInfo() {
			this.$refs.userInfo.close();
		},
		onSwtichFullScreen() {
			this.configStore.setFullScreen(!this.configStore.fullScreen);
		},
		onExit() {
			this.unloadStore();
			this.configStore.setAppInit(false);
			this.$wsApi.close(3000);
			sessionStorage.removeItem("accessToken");
			localStorage.setItem("isAutoLogin", false)
			location.href = "/";
		},
		playAudioTip() {
			if (new Date().getTime() - this.lastPlayAudioTime > 1000) {
				this.lastPlayAudioTime = new Date().getTime();
				let audio = new Audio();
				let url = require(`@/assets/audio/tip.mp3`);
				audio.src = url;
				audio.play();
			}
		},
		showSetting() {
			this.showSettingDialog = true;
		},
		closeSetting() {
			this.showSettingDialog = false;
		},
		loadFriendInfo(id) {
			let friend = this.friendStore.findFriend(id);
			if (!friend) {
				friend = {
					id: id,
					showNickName: "未知用户",
					headImage: ""
				}
			}
			return friend;
		},
		loadGroupInfo(id) {
			let group = this.groupStore.findGroup(id);
			if (!group) {
				group = {
					id: id,
					showGroupName: "未知群聊",
					headImageThumb: ""
				}
			}
			return group;
		}
	},
	computed: {
		unreadCount() {
			let unreadCount = 0;
			let chats = this.chatStore.chats;
			chats.forEach(chat => {
				if (!chat.delete && !chat.isDnd) {
					unreadCount += chat.unreadCount
				}
			});
			return unreadCount;
		}
	},
	watch: {
		unreadCount: {
			handler(newCount, oldCount) {
				let tip = newCount > 0 ? `${newCount}条未读` : "";
				this.$elm.setTitleTip(tip);
			},
			immediate: true
		}
	},
	mounted() {
		if (!this.userStore.userInfo || !this.userStore.userInfo.id) {
			this.$router.push('/login');
			return;
		}
		this.init();
	},
	unmounted() {
		this.$wsApi.close();
	}
}
</script>

<style scoped lang="scss">
.home-page {
	height: 100vh;
	width: 100vw;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 4px;
	overflow: hidden;
	background: var(--im-color-primary-light-9);

	.app-container {
		width: 62vw;
		height: 80vh;
		display: flex;
		min-height: 600px;
		min-width: 970px;
		position: absolute;
		border-radius: 4px;
		overflow: hidden;
		box-shadow: var(--im-box-shadow-dark);
		transition: 0.2s;

		&.fullscreen {
			width: 100vw;
			height: 100vh;
			border-radius: 0;
		}

		.desktop-nav {
			width: 60px;
			height: 100%;
			display: flex;
			flex-direction: column;
			background: #2e2e2e;

			.navi-bar-box {
				height: 100%;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.top {
					.user-head-image {
						padding: 20px 10px;
						display: flex;
						justify-content: center;
						cursor: pointer;
					}

					.menu {
						.link {
							text-decoration: none;

							.menu-item {
								padding: 14px 0;
								display: flex;
								justify-content: center;
								align-items: center;
								position: relative;
								color: #9b9b9b;

								&.router-link-active {
									color: #07c160;
								}

								.icon {
									font-size: 26px;
								}

								.unread-text {
									position: absolute;
									top: 5px;
									right: 5px;
									background: #f56c6c;
									color: white;
									font-size: 10px;
									padding: 1px 4px;
									border-radius: 8px;
									min-width: 14px;
									text-align: center;
									line-height: 1.2;
								}
							}
						}
					}
				}

				.botoom {
					.bottom-item {
						padding: 14px 0;
						display: flex;
						justify-content: center;
						align-items: center;
						color: #9b9b9b;
						cursor: pointer;
						font-size: 18px;

						&:hover {
							color: #07c160;
						}

						.icon {
							font-size: 24px;
						}
					}
				}
			}
		}

		.content-box {
			flex: 1;
			height: 100%;
			overflow: hidden;
			background: white;

			.router-content {
				height: 100%;
			}
		}

		.mobile-nav {
			display: none;
			position: fixed;
			bottom: 0;
			left: 0;
			right: 0;
			height: 50px;
			background: #f7f7f7;
			border-top: 1px solid #e5e5e5;
			justify-content: space-around;
			align-items: center;
			z-index: 100;

			.nav-item {
				display: flex;
				flex-direction: column;
				align-items: center;
				text-decoration: none;
				color: #999;
				position: relative;

				&.router-link-active {
					color: #07c160;
				}

				.icon {
					font-size: 22px;
				}

				.nav-text {
					font-size: 10px;
					margin-top: 2px;
				}

				.unread-badge {
					position: absolute;
					top: -4px;
					right: -12px;
					background: #f56c6c;
					color: white;
					font-size: 10px;
					padding: 1px 5px;
					border-radius: 10px;
				}
			}
		}
	}
}

@media (max-width: 768px) {
	.home-page {
		.app-container {
			width: 100vw;
			height: 100vh;
			min-width: unset;
			min-height: unset;
			border-radius: 0;

			.desktop-nav {
				display: none;
			}

			.mobile-nav {
				display: flex;
			}

			.content-box {
				padding-bottom: 50px;
			}
		}
	}
}
</style>